import { render, staticRenderFns } from "./deleted_debts.vue?vue&type=template&id=5880a430&"
import script from "./deleted_debts.vue?vue&type=script&lang=js&"
export * from "./deleted_debts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports